// @snippet
/**
 * @class Stats
 */
const statsDebug =
  new URL(window.location.href).searchParams.get('statsDebug') !== null|| false;

// Keeps delegated click listeners from being attached twice to the same base node.
const statsEventListenerBases = new WeakSet();
window.dataLayer = window.dataLayer || [];

class Stats {
  static sendEventGA(category, action, label) {
    if (window.ga && ga.create) {
      ga('send', 'event', category, action, label);
    }
  }

  static sendEventGTag(props = {}) {
    if (window.gtag) {
      const event = props.event || 'click';
      if (props.event) {
        delete props.event;
      }
      gtag('event', event, props);
    }
  }

  static sendEventDataLayerViaShopify(props = {}) {
    // if (Shopify?.analytics) {
      const event = props.event || 'gtag-event-click';
      if (props.event) {
        delete props.event;
      }
      //   Shopify.analytics.publish(event, props);
      Stats.sendEvent(event, props);
    // }
  }

  static sendEvent(event, props) {
    const modelContextData = () => ({
      url: document.location.href,
      page_title: document.title,
      page_location: window.location.href,
    });

    let payload = {
      event: event,
      ...props,
      ...modelContextData(),
    };

    window.dataLayer.push(payload);
  }

  static parseGtagData(item) {
    const gtagData = item?.dataset?.gtagData;

    if (!gtagData) {
      return null;
    }

    try {
      return JSON.parse(gtagData);
    } catch (_error) {
      try {
        // Some templates save JSON-like data with single quotes, so normalize as a fallback.
        return JSON.parse(gtagData.split(`'`).join(`"`));
      } catch (error) {
        if (statsDebug) {
          console.warn('Stats: invalid gtag data', gtagData, error);
        }
        return null;
      }
    }
  }

  // Uses event delegation so elements added later by lazy-loaded sections still track clicks.
  static fetchByGtagElements(base = document.querySelector('body')) {
    Stats.listenerOnElements(base);
  }

  static listenerOnElements(base = document.querySelector('body')) {
    if (!base || statsEventListenerBases.has(base)) {
      return;
    }

    statsEventListenerBases.add(base);

    // const base = document.querySelector('body'); // the container for the variable content
    const selector = '.gld-gtag-event--click'; // any css selector for children
    const selectorGA = '.gld-ga-event--click'; // any css selector for children

    const execEvent = (event) => {
      const target = event.target;

      // Find the closest trackable element, even when the user clicks a child node inside it.
      let item = target?.closest?.(selector) || target?.closest?.(selectorGA);

      if (
        !item &&
        (target?.classList?.contains(selector.substring(1)) ||
          target?.classList?.contains(selectorGA.substring(1)))
      ) {
        item = target;
      }
      if (item && base.contains(item)) {
        const props = Stats.parseGtagData(item);

        // Only send when the element has valid data-gtag-data payload.
        if (props) {
          if (statsDebug) {
            console.warn('Stats: valid gtag data', props);
          }
          Stats.sendEventDataLayerViaShopify(props);
        }
      }
    };

    base.addEventListener('click', function (event) {
      execEvent(event);
    });
    // base.addEventListener('mousedown', function (event) {
    //     execEvent(event);
    // });
  }

  static eventsOnLoad() {
    window.addEventListener('load', () => {
      Stats.eventTrafficSource();
    });
  }

  static eventTrafficSource() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const source = urlParams.get('source') || urlParams.get('Source');
    if (source === 'tiktok') {
      Stats.sendEventDataLayerViaShopify({
        event: 'onLoad',
        event_category: 'traffic_source',
        event_action: `visit`,
        event_label: source,
      });
    }
  }
}
export default Stats;
